import { Link } from 'react-router-dom'
import { Instagram } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { CONTACT, SOCIAL, NAV_LINKS, SITE_NAME, ROOMS_ROUTE } from '@/lib/constants'

export function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer style={{ backgroundColor: '#F3EADB', color: '#0F2966', fontFamily: 'Montserrat, sans-serif' }}>
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-10">

        {/* Logo — centered at top */}
        <div className="flex justify-center mb-6">
          <Link to="/" aria-label={SITE_NAME}>
            <img
              src="/images/nuva/logo/logo-footer-actual.jpg"
              alt={SITE_NAME}
              style={{ height: 160, width: 'auto', objectFit: 'contain' }}
            />
          </Link>
        </div>

        {/* Horizontal nav links — centered, same 5 as header */}
        <nav className="hidden md:flex justify-center gap-0 mb-6">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="px-[15px] py-1 text-sm font-bold transition-colors hover:opacity-70"
              style={{ color: '#0F2966' }}
            >
              {t(link.labelKey)}
            </Link>
          ))}
        </nav>

        {/* Horizontal divider */}
        <hr style={{ borderColor: '#0F2966', borderTopWidth: 1, opacity: 0.3, marginBottom: '2rem' }} />

        {/* 3-column info row: contact | RESERVAR button | hours */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 text-center">

          {/* Column 1 — Contact info */}
          <div className="flex flex-col items-center gap-1 text-sm leading-loose" style={{ color: '#0F2966' }}>
            <p className="text-sm font-bold uppercase tracking-wide mb-1" style={{ color: '#0F2966' }}>
              {SITE_NAME}
            </p>
            <p>{CONTACT.address}</p>
            <a href={`tel:${CONTACT.phone}`} className="transition-opacity hover:opacity-70">
              {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="transition-opacity hover:opacity-70 break-all">
              {CONTACT.email}
            </a>
          </div>

          {/* Column 2 — RESERVAR CTA */}
          <div className="flex items-center justify-center">
            <Link
              to={ROOMS_ROUTE}
              className="flex items-center justify-center text-sm font-bold transition-colors"
              style={{
                width: 175,
                height: 50,
                borderRadius: 100,
                backgroundColor: '#0F2966',
                color: '#FFFFFF',
                border: '1px solid #0F2966',
              }}
            >
              RESERVAR
            </Link>
          </div>

          {/* Column 3 — Hours */}
          <div className="flex flex-col items-center gap-1 text-sm leading-loose" style={{ color: '#0F2966' }}>
            <p className="text-sm font-bold uppercase tracking-wide mb-1" style={{ color: '#0F2966' }}>
              HORARIOS
            </p>
            <p>ABIERTO LAS 24 HS</p>
            <p>CHECK-IN: 2:00 PM</p>
            <p>CHECK-OUT: 11:00 AM</p>
          </div>
        </div>

        {/* Instagram icon */}
        {SOCIAL.instagram && (
          <div className="flex justify-center mb-8">
            <a
              href={SOCIAL.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-10 w-10 items-center justify-center rounded-full transition-opacity hover:opacity-70"
              style={{ border: '1px solid #0F2966' }}
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" style={{ color: '#0F2966' }} />
            </a>
          </div>
        )}

        {/* Legal links + copyright */}
        <div className="flex flex-col items-center gap-3 text-center text-xs" style={{ color: '#0F2966' }}>
          <div className="flex items-center gap-2">
            <Link to="/terminos-y-condiciones" className="transition-opacity hover:opacity-70">
              Términos y Condiciones
            </Link>
            <span style={{ color: '#0F2966' }}>|</span>
            <Link to="/privacidad-y-cookies" className="transition-opacity hover:opacity-70">
              Privacidad y Cookies
            </Link>
          </div>
          <p>
            © {currentYear} Hotel Boutique Nueva Valladolid | Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  )
}
